import React from 'react';
import ReactDOM from 'react-dom';
import Filters from './Filters';
import Results from './Results';
import request from 'superagent';
import Pagination from 'react-paginate';
import LoadingAnimation from '../LoadingAnimation';
import queryString from 'query-string';
import Select from 'react-select';
import SiteDefaults from '../SiteDefaults';
import SiteConfig from "../SiteConfigs";
import ErrorBoundary from '../../ErrorBoundary';
import SiteLanguage from '../SiteLanguage';

class SearchPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            data: {},
            filters: {},
            loading: true,
            message: null,
            searchFilters: [],
            searchFilterMain: null,
            states: [],
            site: 0,
            country: 'us',
            site_uid: 1,
            filtersLoading: false,
            siteFilterConfigs: null,
            searchRequest: null,
            filtersRequest: null,
            sites: null,
            countries: null,
            language: {
                loadingTalent: 'Fetching talent...'
            }
        };
    }

    componentDidMount() {
        SiteLanguage.get('search-index', (language, error) => this.setState({ language }));

        SiteConfig.get('bluecompass.mandyHomePage.sitesBase', (sites) => {
            this.setState({ sites }, () => {
                this.loadFromSearchQuery();
            });
        });

        SiteConfig.get('bluecompass.mandyHomePage.countries', (countries) => {
            this.setState({ countries });
        });

        window.addEventListener("popstate", (e) => this.handleBackButton());
    }

    componentWillUnmount() {
        window.removeEventListener("popstate", (e) => this.handleBackButton());
    }

    handleBackButton() {
        this.loadFromSearchQuery(false);
    }

    loadFromSearchQuery(updateHistory = true) {
        let site = 0;
        let parsedQuery = window.location.search ? queryString.parse(window.location.search, { arrayFormat: 'bracket' }) : null;
        let domain = parsedQuery && parsedQuery.domain ? parsedQuery.domain : this.props.site;
        let country = parsedQuery && parsedQuery.country ? parsedQuery.country : (this.props.country ? this.props.country : 'us');

        for (let key in this.state.sites) {
            if (this.state.sites.hasOwnProperty(key) && this.state.sites[key].domain === domain) {
                site = parseInt(key);
            }
        }

        this.setState({ country, site }, () => {
            this.updateFilters(() => {
                this.handleSearch(parsedQuery, updateHistory);
            });
        });
    }

    updateFilters(callback = null) {
        if (this.state.sites) {
            try {
                if (SiteDefaults.contentType(this.state.sites[this.state.site].domain)) {
                    if (localStorage) {
                        localStorage.setItem('mandyPref.contentType', SiteDefaults.contentType(this.state.sites[this.state.site].domain));
                    }
                }
                if (SiteDefaults.detailed(this.state.sites[this.state.site].domain) !== null) {
                    if (localStorage) {
                        localStorage.setItem('mandyPref.detailedView', SiteDefaults.detailed(this.state.sites[this.state.site].domain));
                    }
                }
            } catch (e) {
                Bugsnag.notify('Anyone - SearchPage@updateFilters:', 'localStorage error', { e });
            }

            this.setState({
                searchFilters: [],
                filters: {},
                searchFilterMain: null,
                states: [],
                filtersLoading: true
            }, () => {
                if (this.state.filtersRequest) {
                    this.state.filtersRequest.abort();
                }
                let filtersRequest = request.get(`/search/filters/${this.state.sites[this.state.site].domain}/${this.state.country}`)
                    .end((err, res) => {
                        let filtersRequest = null;
                        if (res && res.body && res.body.success) {
                            this.setState({
                                searchFilters: res.body.data.search_filters,
                                jobTitleFilter: res.body.data.job_title,
                                states: res.body.data.states,
                                site_uid: res.body.data.site_uid,
                                filtersLoading: false,
                                searchFilterMain: res.body.data.search_filter_main ? res.body.data.search_filter_main : null,
                                siteFilterConfigs: res.body.data.site_filter_configs,
                                filters: {
                                    agefrom: res.body.data.site_filter_configs.minage,
                                    ageto: res.body.data.site_filter_configs.maxage
                                },
                                filtersRequest
                            });
                        } else {
                            let message = res && res.body && res.body.message ? res.body.message : 'There was a problem getting the filters. Please try again later.';
                            this.setState({ message, filtersLoading: false, filtersRequest });
                        }
                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    });
                this.setState({ filtersRequest });
            });
        }
    }

    handleSearch(filters = null, updateHistory = true) {
        if (this.state.sites) {
            let page = this.state.page;
            if (filters) {
                page = parseInt(filters.page) ? filters.page : 1;
            } else {
                filters = this.state.filters;
            }

            if (updateHistory) {
                let url = window.location.pathname + '?';
                let stringifiedFilters = queryString.stringify(filters, { arrayFormat: 'bracket' });
                url += filters.country && filters.domain ? stringifiedFilters
                    : 'country=' + this.state.country + '&domain=' + this.state.sites[this.state.site].domain + '&' + stringifiedFilters;
                window.history.pushState({}, '', url);
            }

            this.setState({ filters, page, loading: true, message: null }, () => {
                filters['site_uid'] = this.state.site_uid;
                filters['end_lastlogin'] = this.props.endLastLogin;
                if (this.state.searchRequest) {
                    this.state.searchRequest.abort();
                }
                let searchRequest = request.post('/search?page=' + page)
                    .set('X-Requested-With', 'XMLHttpRequest')
                    .set('X-CSRF-Token', document.querySelector('meta[name="_token"]').content)
                    .send(filters)
                    .end((err, res) => {
                        let searchRequest = null;
                        if (res && res.body && res.body.pagination) {
                            this.setState({
                                data: res.body,
                                page: res.body.pagination.current_page,
                                loading: false,
                                searchRequest
                            }, () => {
                                setTimeout(() => { window.cardLogger.update(); }, 500);
                            });
                        } else {
                            let message = res && res.body && res.body.message ? res.body.message : 'There was a problem executing your request. Please try again later.';
                            this.setState({ data: {}, page: 1, loading: false, message, searchRequest });
                        }
                    });
                this.setState({ searchRequest });
            });
        }
    }

    handlePageClick(page) {
        if (!this.state.loading && page.selected > -1 && page.selected < this.state.data.pagination.last_page) {
            let filters = this.state.filters;
            filters.page = page.selected + 1;
            this.setState({ page: page.selected + 1, filters }, () => {
                this.handleSearch();
            });
        }
    }

    countryOptions() {
        if (this.state.countries && this.state.sites) {
            let countries = this.state.countries.map((item) => ({ value: item.code, label: item.name }));

            if (this.state.site !== null && this.state.sites[this.state.site].hasOwnProperty('countries')) {
                countries = countries.filter((countryOption) => {
                    return this.state.sites[this.state.site].countries.indexOf(countryOption.value) !== -1;
                });
            }

            return countries;
        }
    }

    handleSiteChange(name, value) {
        let stateUpdate = {};
        stateUpdate[name] = value;
        this.setState(stateUpdate, () => this.updateFilters());
    }

    pageItemClassName() {
        return 'page-item cursor-pointer ' + (this.state.loading ? 'disabled' : '');
    }

    render() {
        return (
            <div>
                <Filters states={this.state.states}
                    searchFilters={this.state.searchFilters}
                    handleSearch={(filters) => this.handleSearch(filters)}
                    mainFilter={this.state.searchFilterMain}
                    siteConfigs={this.state.siteFilterConfigs}
                    loading={this.state.filtersLoading}
                    jobTitleFilter={this.state.jobTitleFilter}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <Select
                                    name="site"
                                    value={this.state.site}
                                    options={this.state.sites ? this.state.sites.map((item, index) => ({
                                        label: item.mainTitle,
                                        value: index
                                    })) : []}
                                    onChange={(val) => this.handleSiteChange('site', val.value)}
                                    clearable={false}
                                    className="Select-bootstrap"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <Select
                                    name="country"
                                    value={this.state.country}
                                    options={this.countryOptions()}
                                    onChange={(val) => this.handleSiteChange('country', val.value)}
                                    clearable={false}
                                    className="Select-bootstrap"
                                />
                            </div>
                        </div>
                    </div>
                </Filters>
                <hr />
                <p>{this.state.message}</p>
                {this.state.loading ? <LoadingAnimation loadingText={this.state.language.loadingTalent} /> : (
                    <Results
                        data={this.state.data}
                        onNav={(dir) => {
                            //TODO: Maybe preload the next or previous 16?
                        }}
                        onNavEnd={(dir) => {
                            this.handlePageClick({ selected: this.state.page + dir - 1 });
                        }} />
                )}

                <nav aria-label="Page navigation" className={this.state.loading ? 'disabled' : ''}>
                    <Pagination
                        previousLabel="previous"
                        nextLabel="next"
                        breakLabel={<span className="page-link">...</span>}
                        breakClassName="page-item"
                        pageCount={this.state.data.pagination ? this.state.data.pagination.last_page : 1}
                        forcePage={this.state.page - 1}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={2}
                        onPageChange={(page) => this.handlePageClick(page)}
                        containerClassName="pagination justify-content-center"
                        pageClassName={this.pageItemClassName()}
                        pageLinkClassName="page-link cursor-pointer"
                        activeClassName="active"
                        previousClassName={this.pageItemClassName()}
                        nextClassName={this.pageItemClassName()}
                        previousLinkClassName="page-link cursor-pointer"
                        nextLinkClassName="page-link cursor-pointer"
                    />
                </nav>
            </div>
        );
    }
}

let SearchPageElement = document.getElementsByClassName('SearchPage');
if (SearchPageElement.length > 0) {
    let endLastLogin = SearchPageElement[0].getAttribute('data-endLastLogin');
    let site = SearchPageElement[0].getAttribute('data-site');
    let country = window.geoCountry;

    ReactDOM.render(
        <ErrorBoundary>
            <SearchPage site={site} contry={country} endLastLogin={endLastLogin} />
        </ErrorBoundary>, SearchPageElement[0]);
}